import { useNavigate } from 'react-router-dom'
import { useDbValue } from '../lib/useDbValue.js'
import { pendingForToken } from '../lib/qualifyStatus.js'

const GREEN = '#123D26'
const GOLD = '#C2A24E'

// GLOBAL persistent "Start Qualifying" pill. Mounted app-wide (App.jsx) so it
// follows a pending, token-bound team onto EVERY player screen — hub, leaderboard,
// brackets, photos — and never disappears until they qualify. Tapping it opens the
// qualify flow (which then asks scorecard vs. final total). It renders nothing
// unless this device is bound to a still-pending team. App.jsx already hides it on
// /play (the team home has its own two buttons) and /qualify (already there).
export default function QualifyFollow() {
  const navigate = useNavigate()
  const bound = readToken()
  const tid = bound?.tid || null
  const token = bound?.token || null
  const { data: tournament } = useDbValue(tid ? `tournaments/${tid}` : null)
  if (!tid || !token || !tournament) return null
  const { pending, teamId } = pendingForToken(tournament, token)
  if (!pending) return null

  let inProgress = false
  try {
    const s = JSON.parse(localStorage.getItem(`tq_${tid}_${teamId}`) || 'null')
    inProgress = !!(s && (Object.keys(s.scores || {}).length > 0 || s.step === 'manual'))
  } catch { /* ignore */ }

  return (
    <button
      onClick={() => navigate(`/play?t=${encodeURIComponent(tid)}&tk=${encodeURIComponent(token)}&q=1`)}
      aria-label={inProgress ? 'Resume qualifying' : 'Start qualifying'}
      style={{
        position: 'fixed', left: '50%', transform: 'translateX(-50%)',
        bottom: 'calc(16px + env(safe-area-inset-bottom))', zIndex: 9997,
        background: GREEN, color: '#FFFFFF', border: `1.5px solid ${GOLD}`, borderRadius: 999,
        padding: '13px 26px', fontWeight: 800, fontSize: 15, cursor: 'pointer',
        boxShadow: '0 8px 22px rgba(0,0,0,0.4)', whiteSpace: 'nowrap',
      }}>
      ⛳ {inProgress ? 'Resume Qualifying' : 'Start Qualifying'}
    </button>
  )
}

function readToken() {
  try {
    const s = JSON.parse(localStorage.getItem('play_token') || 'null')
    if (s?.token && s?.tid) return { tid: s.tid, token: s.token }
  } catch { /* ignore */ }
  return null
}
